import { createContext, useContext } from 'react';
export const LanguageContext = createContext(undefined);
export default function useLanguageContext() {
    const data = useContext(LanguageContext);
    if (data === undefined)
        throw new Error('Context is undefined');
    return data;
}
